import { mapInternalServiceType } from './mapInternalServiceType';

/**
 * Преобразует массив шарповых (internal) типов услуг в питонячие (public)
 */
export const mapInternalServiceTypes = <T>(serviceTypes: Array<string>): Array<T> => {
  return serviceTypes.map(mapInternalServiceType).filter(Boolean) as unknown as Array<T>;
};
